import { render, staticRenderFns } from "./MessagesContainer.vue?vue&type=template&id=eaae0ae2&"
import script from "./MessagesContainer.vue?vue&type=script&lang=js&"
export * from "./MessagesContainer.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/messages/messages-container.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports